import { assetsModule } from "@/store";

interface Album {
  id: string;
  slug: string;
  parentId: string | null;
}

interface Asset {
  id: string;
  slug: string;
  albumId: string;
}

export function getAllAlbums(): Album[] {
  return (assetsModule.getAlbumsWithoutAssets as Album[]) || [];
}

function leafAlbumId(slugs: string[]): string | null {
  if (!slugs.length) {
    return null;
  }

  const albums = getAllAlbums();

  if (!albums.length) {
    return null;
  }

  const byParent: Record<string, Record<string, Album>> = {};

  for (const a of albums) {
    const pid = a.parentId ?? "_";

    (byParent[pid] ||= {})[a.slug] = a;
  }

  let parent: string | null = null;
  let leaf: Album | undefined;

  for (const seg of slugs) {
    const bucket: Record<string, Album> = byParent[parent ?? "_"];

    if (!bucket) {
      return null;
    }

    leaf = bucket[seg];

    if (!leaf) {
      return null;
    }

    parent = leaf.id;
  }
  return leaf ? leaf.id : null;
}

const SPECIAL_ALBUM_SLUGS = new Set(["newest"]);
export const hasSpecialAlbumSlug = (slugs: string[]): boolean => {
  return slugs.some((slug) => SPECIAL_ALBUM_SLUGS.has(slug));
};

export const isAlbumSlugChainValid = (slugs: string[]): boolean => {
  if (hasSpecialAlbumSlug(slugs)) {
    return true;
  }

  return !!leafAlbumId(slugs);
}

export const isAssetSlugValid = (
  albumSlugs: string[],
  assetSlug: string
): boolean => {
  if (!assetSlug) {
    return false;
  }

  const albumId = leafAlbumId(albumSlugs);

  if (!albumId) {
    return false;
  }

  const assets: Asset[] = assetsModule.getAssets || [];

  if (!assets.length) {
    return false;
  }

  return assets.some((a) => a.albumId === albumId && a.slug === assetSlug);
}
